const loadNIASScript = (user, token, id='nias') => {
  const messageId = user ? user.messageId : null
  const navToken = user ? user.navToken : null
  
  let showLoginButon = token ? true : false

  const scriptExist = document.getElementById('nias')
  if (scriptExist) {
    document.getElementById('nias').remove()
  }

  let scriptSrc = `${process.env.REACT_APP_NIAS_NAVBAR_URL}?language=hr
  &login_url=${process.env.REACT_APP_NIAS_LOGIN_URL}/?token=${token}
  &logout_url=${process.env.REACT_APP_NIAS_LOGOUT_URL}
  &messageId=${messageId}
  &nav_token=${navToken}
  &show_login_button=${showLoginButon}
  &show_font_resize=false
  &show_vision_impaired=false
  `;
  
  const script = document.createElement('script');
  script.id = id;
  script.src = scriptSrc.replace(/(\r\n|\n|\r)/gm, "").replace(/ /g,'');
  script.async = true;
  document.body.appendChild(script)  

};

export default loadNIASScript